import React from 'react';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';

const NoteColorSelector = (props) => {
  const { setColor } = props;

  switch (props.type) {
    case 'background_color':
      return (
        <span className="font-color-selector-wrapper">
          <input
            className="font-color-selector"
            type="color"
            onChange={setColor}
          />
          <FormatColorFillIcon />;
        </span>
      );
    case 'font_color':
      return (
        <span className="font-color-selector-wrapper">
          <input
            className="font-color-selector"
            type="color"
            onChange={setColor}
          />
          <FormatColorTextIcon />;
        </span>
      );
    default:
      return null;
  }
};

export default NoteColorSelector;
